import { connect, postToParent } from '@instructure/quiz-core';
import { GradingBar as GradingBarPresenter } from './presenter';
export var mapStateToProps = function mapStateToProps(state) {
  return {
    activeItemId: state.getIn(['grading', 'activeItemId']),
    gradeByQuestionEnabled: state.getIn(['grading', 'gradeByQuestionEnabled'])
  };
};
var mapDispatchToProps = {
  postToParent: postToParent
};
export var GradingBar = connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true
})(GradingBarPresenter);
export default GradingBar;